import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, OFFER_ANCHOR, systemFeatures } from '../data/fono';
export function SystemSection() {
  return <section className="bg-cream px-3 py-5 sm:py-7" data-id="element-161" data-mp="3bidf2dt104at">
      <div className="mx-auto max-w-4xl" data-id="element-162" data-mp="3bkzpcl7awxwq">
        <h2 className="text-center text-xl leading-tight text-teal sm:text-3xl" data-id="element-163" data-mp="36kbol7t9t2pb">
          The Complete 6-in-1 Visual Activity System
        </h2>

        <div className="mt-3 grid items-center gap-4 sm:grid-cols-2" data-id="element-164" data-mp="31m0ecvz2cq6k">
          <a href={OFFER_ANCHOR} className="block" data-id="element-165" data-mp="2wsxqn4gywaya">
            <img src={BOX_IMAGE} alt="The six modules and five bonuses of FONO KIDS PRO™" className="mx-auto w-full max-w-[280px] drop-shadow-xl transition-transform duration-200 ease-soft hover:scale-[1.02] sm:max-w-none" data-id="element-166" data-mp="2ssezlcmwf8x5" />
          </a>

          <div data-id="element-167" data-mp="2iw25wercsv2e">
            <p className="font-display text-xl font-extrabold uppercase leading-none text-teal sm:text-2xl" data-id="element-168" data-mp="2dvej65a5r0dz">
              🗣️ FONO KIDS PRO™
            </p>
            <p className="mt-1 text-[11px] font-extrabold uppercase tracking-wide text-coral sm:text-sm" data-id="element-169" data-mp="13xwu5aqxvgzc">
              Ready-to-use visual activities for pediatric speech-language professionals
            </p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-wide text-charcoal/70" data-id="element-170" data-mp="tyxlvta35ncv">
              Speech • Language • Vocabulary • Phonological Awareness • Auditory Skills •
              Narrative
            </p>

            <ul className="mt-2.5 space-y-1" data-id="element-171" data-mp="1roisgab55mw5">
              {systemFeatures.map(feature => <li key={feature} className="flex items-start gap-2 text-[13px] font-semibold leading-snug text-charcoal" data-id="element-172" data-mp="1crs0un7plfh3">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-turq" aria-hidden="true" data-id="element-173" data-mp="1hsfqp5k7bq9q" />
                  {feature}
                </li>)}
            </ul>

            <CTAButton className="mt-3" data-id="element-174" data-mp="28ymnb5p2kh5l">🗣️ YES! I WANT THE COMPLETE SYSTEM</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}